<!-- Макет: https://www.figma.com/file/reAk2sU4YpRajpQu2YBOHk/002%2F1.-Элементы?type=design&node-id=8799-185065&mode=design&t=QIYkr2Df5aRVaiQq-0 -->
<template>
  <figure class="goods-gallery-item">
    <a
      class="goods-gallery-item__image-box"
      :href="item.url"
      target="_blank"
      @click="trackImageClick"
    >
      <img
        class="goods-gallery-item__image"
        :src="item.image.url"
        :width="item.image.width"
        :height="item.image.height"
        :alt="item.label"
      />
    </a>
    <figcaption
      v-if="item.label"
      class="goods-gallery-item__caption"
    >
      <a
        :href="item.url"
        target="_blank"
        @click="trackCaptionClick"
      >
        {{ item.label }}
      </a>
    </figcaption>
  </figure>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import type { GoodsGalleryItem } from './GoodsGallery.vue';

  export default defineNuxtComponent({
    name: 'GoodsGalleryItem',

    props: {
      item: {
        // @ts-ignore
        type: Object as PropType<GoodsGalleryItem>,
        required: true,
      },
    },

    methods: {
      trackImageClick() {
        this.sendAnalyticsData('Клик_изображение в галерее товара');
      },

      trackCaptionClick() {
        this.sendAnalyticsData('Клик_ссылка в галерее товара');
      },

      sendAnalyticsData(name: string) {
        this.$sendYandexMetrika({
          level1: name,
          level4: this.item.url,
        });
      },
    },
  });
</script>

<style lang="scss" scoped>
  .goods-gallery-item {
    position: relative;
    margin: 0;
    overflow: hidden;

    &__image-box {
      overflow: hidden;
      display: block;
    }

    &__image {
      aspect-ratio: var(--aspect-ratio);
      object-fit: cover;
      transition: transform 0.3s ease-in-out;
      display: block;
    }

    &__caption {
      @include lineClampEllipsis();
      margin-top: 8px;
      font-size: 12px;
      line-height: 18px;
      text-align: center;
    }

    &__image-box:hover img {
      transform: scale(1.1);
    }
  }
</style>
